import React, { Component } from 'react'
import ReportJobControlBoard from '../../report/ReportJobControlBoard'
import RecheckEdit from './RecheckEdit'
import { Breadcrumb } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import {connect} from 'react-redux'
const jobState = {  
  0: 'กำลังทำงาน',
  2: 'ทำงานเสร็จ',
  3: 'เลยกำหนดเวลา',
  4: 'งานแก้ไข'
};

const jobStyle = {  
  0: { color: 'orange', class: 'orange-print' },
  2: { color: 'blue', class: 'blue-print' },
  3: { color: 'red', class: 'red-print' },
  4: { color: 'pink', class: 'pink-print' }
}



class RecheckControlPage extends Component {

  constructor(...args) {
    super(...args)
    this.state = { showReport: true,workNo:'' }
    this.jobControl = null
    this.defaultHeaderTitles = [
      { title: this.props.messages['Fixing Job No'], field: 'work_no', sorting: true, direction:'', onClick:()=>{} },
      { title: this.props.messages['Car Registration'], field: 'car_registration_no' },
      { title: this.props.messages['Brand/Model'], field: 'car_detail' },
      { title: this.props.messages['Customer'], field: 'customer_name' }    
    ]
  }

  onRowClick(row,workState) {
    this.setState({ showReport: false,workNo:row.work_no }, () => {this.refs.jobEdit.loadWorkJob(row,workState)})
  }

  onStateChange(workNo, taskstate) {
    if(this.jobControl!==null)
      this.jobControl.updateWorkNo(workNo, taskstate)
    
    this.setState({workNo:workNo})  
  }

  renderBreadcumb(){
    const {workNo} = this.state
    return (
      <Breadcrumb>
        <Breadcrumb.Item href="#" onClick={()=>{this.setState({ showReport: true })}}><FontAwesome name="table"/> ตารางควบคุมงานภายใน</Breadcrumb.Item>
        <Breadcrumb.Item href="#">
          <FontAwesome name='file-o'/> งานซ่อมเลขที่ {workNo}
        </Breadcrumb.Item>            
      </Breadcrumb>      
    )    
  }

  render() {
    let { showReport } = this.state
    return (
      <div>
        <ReportJobControlBoard 
            onRef={(ref)=>{this.jobControl = ref}}  
            control='recheck'
            show={showReport} 
            showCheckMechanic={false}
            jobState={jobState}
            jobStyle={jobStyle}            
            // onRowClick={this.onRowClick.bind(this)} 
            defaultHeaderTitles={this.defaultHeaderTitles}
            onRowClick={()=>{}}
        />
        {/* {(!showReport) && this.renderBreadcumb()}
        <RecheckEdit 
            ref='jobEdit' 
            control='recheck'
            show={!showReport}
            jobState={jobState}
            jobStyle={jobStyle}
            onStateChange={this.onStateChange.bind(this)}
            onClose={() => { this.setState({ showReport: true }) }} 
        /> */}
      </div>
    )
  }
}



export default RecheckControlPage = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.JobControlBoardTable}),null,null,{withRef:true}
)(RecheckControlPage);





// WEBPACK FOOTER //
// ./src/view/workdoc/recheckcontrol/RecheckControlPage.js